<template>
  <b-row>
    <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start mb-1" >
      <span class="text-muted">
        Showing 
        {{ start }} to 
        {{ paginationPageEntry }} of {{ pagination.Count }} entries
      </span>
    </b-col>
    <b-col
      cols="12"
      sm="6"
      class="d-flex align-items-center justify-content-center justify-content-sm-end"
    >
      <b-pagination
        v-model="pagination.PageIndex"
        :total-rows="pagination.Count"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="custom-pagination"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    pagination() {
      return this.$store.state.sampleDatabase.filterQuery;
    },
    paginationPageEntry() {
      const pageEntryCount = (this.pagination.PageIndex * this.pagination.PageSize);
      if (pageEntryCount > this.pagination.Count) {
        return this.pagination.Count;
      }
      return pageEntryCount;
    },
    start() {
      return this.pagination.PageIndex > 1 ? (this.pagination.PageIndex - 1) * this.pagination.PageSize : '1';
    },
  },
  methods: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>
